type ObjectFit = "fill" | "contain" | "cover" | "none" | "scale-down";

type RecordCoverProps = {
  imageSrcUrl: string;
  alt?: string;
  objectFit?: ObjectFit | undefined;
  loading?: "lazy" | "eager" | undefined;
};

const Image = ({
  imageSrcUrl,
  alt,
  loading = "lazy",
  objectFit = "cover",
}: RecordCoverProps) => {
  return (
    <img
      width="100%"
      height="100%"
      style={{
        width: "100%",
        height: "100%",
        objectFit: objectFit,
      }}
      className="h-auto w-full object-cover shadow-black transition-all duration-300 group-hover:shadow-2xl group-hover:shadow-cyan-200"
      src={imageSrcUrl}
      alt={alt ?? ``}
      loading={loading}
    />
  );
};
export default Image;
